import styled from 'styled-components'
import ImgUtil from '../../../utils/img.utils'

export const ResourceRowContainer = styled.div`
  padding: 64px 0 0 0;
  background: rgb(247, 247, 247);

  .ResourseRow_Intro {
    text-align: center;
  }

  .ResourseRow_Intro + div {
    padding-top: 64px;
  }
`

export const TimezoneOverrideContainer = styled.div`
  text-align: center;
  padding: 128px 0;
  background: url(${ImgUtil.getResizedImageUrl(
    'https://images.ctfassets.net/5965pury2lcm/2bhf6WFigf5S0bbnPUZHQ2/0bcf8eb01c4e27636199c0efecc7f7fa/Timezone-Thankyou-BG.jpg',
    ''
  )});
  background-size: cover;
  background-repeat: no-repeat;
  .TimeZoneOverried__Icon {
    width: 64px;
    height: 64px;
    margin-bottom: 32px;
  }
  .EmbeddedIconButton {
    margin: 32px 0;
  }
`
